export default __webpack_public_path__ + "static/media/btn-itunes.79a4797c.webp";